
<ng-template #template1>
    <div class="modal-content"> 
        <div class="modal-header">
            <h5 class="modal-title">Switch Store</h5>
        </div>
        <div class="modal-body">
            <div class="mx-0">
                <p>Stores : </p>
                <!-- <select class="form-control" [(ngModel)]="lastAccessed">
                    <option value="0" disabled selected>Select</option>
                    <option [value]="item.Id" *ngFor="let item of storeList">{{item.Name}}</option>
                </select> -->

                <ejs-dropdownlist id='stores' [dataSource]='storeList' [fields]='fields' (filtering)='onFiltering($event)' [filterBarPlaceholder]="filterPlaceholder"
                [popupHeight]='height' [allowFiltering]='true' [placeholder]='watermark' (open)='onDropdownOpen()'
                [(ngModel)]="lastAccessed"></ejs-dropdownlist>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary me-3" (click)="cancelSwitchStore()" i18n="@@Cancel"
                [disabled]="!lastAccessed || lastAccessed === 0">Cancel</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="saveChangedLocation()"
                [disabled]="!lastAccessed || lastAccessed === 0">Select</button>
        </div>
    </div>
</ng-template>
<ng-template #template>
    <div class="modal-content"> 
        <div class="modal-header">
            <h5 class="modal-title">store facility</h5>
        </div>
        <div class="modal-body">
            <div class="row mx-0">
                <label>User does not have sufficient privileges to access the Store. Please contact Administrator.</label>
                <!-- <select class="form-control" [(ngModel)]="lastAccessed">
                    <option value="0" disabled selected>Select</option>
                    <option [value]="item.Id" *ngFor="let item of storeList">{{item.Name}}</option>
                </select> -->
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary me-3" (click)="redirect()" i18n="@@Ok"
                >Ok</button>
            <!-- <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="saveChangedLocation()"
                [disabled]="lastAccessed === null || lastAccessed === 0">Select</button> -->
        </div>
    </div>
</ng-template>

